import React from 'react';
import { Redirect, Link, withRouter } from 'react-router-dom';
import { Switch, Space, Select, Input, Button, Modal, Row, Col, Form, DatePicker, message, Checkbox, Radio, Pagination, Tag,Upload,Image  } from 'antd';
import store from "../store/store.js";
import { EditOutlined,PlusOutlined,LoadingOutlined } from '@ant-design/icons'
import ReactJson from 'react-json-view'
import moment from 'moment';
const { Option } = Select;
const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;

export default class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {
                id: props.id ? props.id : 0,
                gslx: 1,
            },
            visible: false,
            loading: false
        };
    }
    componentDidMount() {
        let that = this
    }
    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, { [name]: value })
        this.setState({
            condition: data
        })
    }
    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, { [name]: value })
        this.setState({
            condition: data
        })
    }
    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.condition, { [name]: dateString })
        this.setState({
            condition: data
        })
    }
    mdchange() {
        let that = this
        let visible = !that.state.visible
        that.setState({
            visible
        })
        if (visible) {
            // if(this.state.condition.id){
            fetch('/Record/view', {
                method: "POST",
                body: JSON.stringify({
                    id: this.state.condition.id
                })
            })
                .then(res => res.json())
                .then(data => {

                    if (this.state.condition.id) {
                        that.setState({
                            condition: data.data,
                        })
                    }
                })
            // }
        } else {
            that.setState({
                condition: {
                    id: this.props.id,
                    gslx: 1,
                },
                loading: false
            })
        }
    }
    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Option value={Number(item.id)} key={index}>{item.name}</Option>
            )
        }
    }
    // 上传图片
    picChange(name,info) {
        // console.log(name,info)
        if (info.file.status === 'uploading') {
            this.setState({ loading2: true });
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            console.log(info.file.response)

            // var fjlist = this.state.condition.fjlist
            // fjlist = fjlist.concat(info.file.response)
            if (info.file.response.status == 0) {
                message.error(info.file.response.msg)
                return;
            }
            let data = Object.assign({}, this.state.condition, { [name]: info.file.response.url })
            this.setState({
                condition: data,
                loading2: false,
            })
        }
    };
    addzzry =(e,arr)=>{
        console.log(arr)
        let zzry = this.state.condition.zzry.concat(arr)
        // zzry.splice(index,1)
        console.log(zzry)
        let data = Object.assign({}, this.state.condition, { zzry: zzry })
        this.setState({
            condition: data
        })
    }
    render() {
        return (
            <>
                <a href='javascript:void(0)' onClick={this.mdchange.bind(this)} >查看</a>
                <Modal title="操作记录详情" maskClosable={true} destroyOnClose={true} width={1200} visible={this.state.visible} onCancel={this.mdchange.bind(this)} footer={null}>
                    <Form
                        layout="vertical"
                        // labelCol={{ span: 4 }}
                        wrapperCol={{ span: 24 }}
                        autoComplete="off"
                        className='addview'

                    >
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="操作时间"
                                >
                                    <Input placeholder="请输入"  value={this.state.condition.addtime ? this.state.condition.addtime : ''} disabled={true} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="用户名"
                                >
                                    <Input placeholder="请输入"  value={this.state.condition.username ? this.state.condition.username : ''} disabled={true} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="姓名"
                                >
                                    <Input placeholder="请输入"  value={this.state.condition.name ? this.state.condition.name : ''} disabled={true} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="操作栏目"
                                >
                                    <Input placeholder="请输入"  value={this.state.condition.lanmu ? this.state.condition.lanmu : ''} disabled={true} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="IP地址"
                                >
                                    <Input placeholder="请输入"  value={this.state.condition.ip ? this.state.condition.ip : ''} disabled={true} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="请求方法"
                                >
                                    <Input placeholder="请输入"  value={this.state.condition.url ? this.state.condition.url : ''} disabled={true} />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={24}>
                                <Form.Item
                                    label="请求参数"
                                >
                                    {/* <TextArea rows={6} placeholder="请输入" value={this.state.condition.content ? this.state.condition.content : null} disabled={true} /> */}
                                    <ReactJson name={false} displayDataTypes={false} src={this.state.condition.content ? this.state.condition.content : null} />
                                </Form.Item>
                            </Col>

                        </Row>

                    </Form>
                </Modal>
            </>
        )
    }
}
